import { getRouteOrganizationBearerHeaders } from "@/utils/auth/organization-token"

import {
  FINDINGS_API_PATH,
  parseInvestigationFindings,
} from "../utils/investigationFindings"

export async function loadExactInvestigationFinding({
  findingId,
  workspaceId,
  organizationSlug,
  signal,
}: {
  findingId: string
  workspaceId: string
  organizationSlug?: string | null
  signal: AbortSignal
}) {
  const query = new URLSearchParams({
    workspace: workspaceId,
    finding_id: findingId,
  })
  if (organizationSlug) {
    query.set("organization", organizationSlug)
  }
  const response = await fetch(`${FINDINGS_API_PATH}?${query.toString()}`, {
    cache: "no-store",
    headers: await getRouteOrganizationBearerHeaders(),
    signal,
  })
  if (response.status === 404) {
    return null
  }
  if (!response.ok) {
    throw new Error("The linked finding could not be loaded")
  }
  const page = parseInvestigationFindings(await response.json())
  if (page?.workspaceId !== workspaceId) {
    throw new Error("The linked finding response did not match the workspace")
  }
  return (
    page.findings.find((finding) => finding.findingId === findingId) ?? null
  )
}
